import {
  makeStateKey,
  TransferState
} from '@angular/platform-browser';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { TranslocoLoader, Translation } from '@jsverse/transloco';
import { Observable, of } from 'rxjs';

import * as ru from '../../assets/i18n/ru.json';
import * as ua from '../../assets/i18n/ua.json';

const TRANSLATIONS = {
  ru,
  ua,
};

@Injectable({ providedIn: 'root' })
export class TranslocoUniversalLoader implements TranslocoLoader {
  constructor(
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  getTranslation(lang: string): Observable<Translation> {
    const key = makeStateKey<Translation>(`TRANSLOCO_${lang.toUpperCase()}`);

    if (this.transferState.hasKey(key)) {
      const data = this.transferState.get(key, {} as Translation);
      return of(data);
    }

    const translation = TRANSLATIONS[lang] || {};
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(key, translation);
    }

    return of(translation);
  }
}
